/**
 * Customer Billing route (CLA-614).
 *
 * Eagerly registers the `/clawinstall/dashboard/billing` file route but defers
 * the component to `.lazy.tsx` so the billing chunk stays out of the main
 * customer-dashboard bundle. Nests under the `dashboard.tsx` layout — the header
 * Billing link and the agent-detail Billing tab (`DASHBOARD_BILLING_HREF`) both
 * point here, so this fixes the dead link surfaced in the 2026-07-07 web-UX
 * audit.
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/clawinstall/dashboard/billing")({});
